module.exports = __webpack_public_path__ + "static/media/logo.753d2880.svg";